import React, { Fragment } from 'react';

//Contexts
import { v4 as uuid } from 'uuid';
import { BaseFormViewModel } from '../common/ViewModel';
import { FlexRow, onFieldChange, toasty } from '../common/forms/FormElements';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import { SalesOrderTrackingEngineerChangeOrderViewDTO } from './SalesOrderTracking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faTimes, faClipboardCheck} from '@fortawesome/free-solid-svg-icons'
import {
    AppPageForm,
    FlexCenterRow,
    FormGroupColumn,    
    GroupedRow,
} from '../common/forms/FormElements';
import 'react-datepicker/dist/react-datepicker.css';

import { Collapse, LinearProgress } from '@material-ui/core';
import { util } from '../Util';

import {
    Button,
    Table
} from 'reactstrap';

import { withRouter } from 'react-router-dom';
import { handleFormSaveError } from '../common/forms/ValidationError';
import authService from '../api-authorization/AuthorizeService';
import { getUserProfile } from '../common/UserProfile';
import FormErrorResponseDisplay from '../common/forms/FormErrorResponseDisplay';

//#endregion

class SalesOrderTrackingEngineerChangeOrderView extends React.Component {

    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        const abortController = new AbortController();

        this.state = Object.assign(
            {
                loadError: false,
                formOpened: false,
                salesorderTrackingId: null,
                workCenterId: 0,
                engineerChangeOrderViewDTO: new SalesOrderTrackingEngineerChangeOrderViewDTO(),
                errorResponse: {},                
                perms: [],
                abortController: abortController,
                showHidden: false
            },
            new BaseFormViewModel()
        );
        this.handleSaveError = this.handleSaveError.bind(this);
    }

    componentDidMount = () => {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount = async () => {
        await authService.unsubscribe(this._subscription);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps && (this.props.match.params.id !== (prevProps.match.params ?? {}).id)) {
            this.populateState();
        }
    }

    async populateState() {
        const isAuthenticated = await authService.isAuthenticated();

        if (!!isAuthenticated) {            
            const { id, rwcId } = { ...this.props.match.params };
            const { abortController } = { ...this.state };

            const { userPermissions } = await getUserProfile();

            if (!!id) {
                await this.setState({
                    loading: true,
                    errors: {},
                    warnings: {}
                });

                var [
                    engineeringChangeOrderResponse
                ] = await Promise.all([
                    util.fetch.get(
                        ApiRoutes.SalesOrderTracking.engineeringChangeOrderView(id),
                        util.fetch.format.none,
                        { signal: abortController.signal }
                    )
                ]);

                //Handle any issues fetching data
                if (!engineeringChangeOrderResponse.ok) {
                    //Handle erroneous links entered by the user
                    if (engineeringChangeOrderResponse.status === 404)
                        this.props.history.push(AppNavPaths.NotFound);
                    else
                        this.props.history.push(AppNavPaths.ServerError);
                    return false;
                } else {
                    
                    let changeorder = await engineeringChangeOrderResponse.json();

                    if (changeorder.result == "ERROR") {
                        let errors = {};
                        errors["Failed to Load"] = changeorder.message;
                        this.notifyError("Failed to Load");
                        await this.setState({    
                            salesorderTrackingId: id,
                            workCenterId: rwcId || 0,
                            formOpened: false,
                            formValidated: false,
                            loading: false,
                            saving: false,
                            errorResponse: {},
                            errors: errors,
                            loadError: true
                        });
                    } else {
                        await this.setState({
                            salesorderTrackingId: id,
                            workCenterId: rwcId || 0,
                            engineerChangeOrderViewDTO: changeorder.data,                            
                            loading: false,
                            saving: false,
                            errorResponse: {},
                            perms: userPermissions
                        });
                    }
                }
            } else {
                await this.setState({
                    salesorderTrackingId: id,
                    workCenterId: rwcId || 0,
                    formOpened: false,
                    formValidated: false,
                    loading: false,
                    saving: false,
                    errorResponse: {},
                    loadError: true
                });
            }
        }
    }

    //#region METHODS
    onChange = onFieldChange;

    onClearErrorNotificationClicked = e => {
        e.stopPropagation();
        this.setState({ errors: {} });
    }

    onClearWarningNotificationClicked = e => {
        e.stopPropagation();
        this.setState({ warnings: {} });
    }        

    clearSaving = () => this.setState((state) => { return { saving: false }; });

    notifyError = (message) => toasty.error('Save Unsuccessful', message);
    handleSaveError = (err) => handleFormSaveError(this, err);

    displaySaveErrors = (response) => this.setState((state) => { return { errorResponse: response }; });
    clearSaveErrors = () => this.setState((state) => { return { errorResponse: {} }; });

    onCloseClicked = () => {
        let { salesorderTrackingId, workCenterId } = { ...this.state };

        if (workCenterId) {
            this.props.history.push(`${AppNavPaths.WorkCenterWorkFlow}/${workCenterId}/${salesorderTrackingId}`)
        } else {
            this.props.history.push(`${AppNavPaths.SalesOrderTracking}/${salesorderTrackingId}`)
        }
    };

    onToggleHidden = () => {
        let { showHidden } = { ...this.state };

        this.setState({
            showHidden: !showHidden
        });
    };

    //#endregion

    //#region RENDERING
    render() {
        let {
            engineerChangeOrderViewDTO,                        
            loading,
            errorResponse,
            loadError,                        
            errors,
            warnings,
            showHidden
        } = { ...this.state };

        if (!!loading) {
            return (<LinearProgress variant="indeterminate" color="secondary" />);
        } else {

            return (
                <Fragment>
                    <AppPageForm
                        formId={"engineeringChangeOrderForm"}
                        formHeadingIcon={faClipboardCheck}
                        formHeading={`Engineering Change Order for: ${engineerChangeOrderViewDTO.serialNumber}`}
                        formName={"engineeringChangeOrderForm"}
                        formRef={this.formRef}
                        onSubmit={this.onSubmit}
                        setIsValidated={(value) => { this.setState({ formValidated: value }) }}
                        isValidated={this.state.formValidated}
                        saving={this.state.saving}
                        errors={errors}
                        warnings={warnings}
                        loading={this.state.loading}
                        onClearErrors={this.onClearErrorNotificationClicked}
                        onClearWarnings={this.onClearWarningNotificationClicked}
                        ValidationBottom={true}
                    >
                        {!!loadError && 
                            <GroupedRow>
                                <FormGroupColumn>
                                    <p>{"Could Not Load Change Order. Please report this error."}</p>
                                </FormGroupColumn>
                            </GroupedRow>
                        }
                        {!!!loadError &&
                            <Fragment>
                                <FlexCenterRow>
                                    <Table style={{ width: "100%" }}>
                                        <colgroup>
                                            <col style={{ width: "30%" }} />
                                            <col style={{ width: "20%" }} />
                                            <col style={{ width: "50%" }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>Component</th>
                                                <th>Change</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!(engineerChangeOrderViewDTO.changes?.filter(c => !c.hidden) ?? []).length && 
                                                (engineerChangeOrderViewDTO.changes?.filter(c => !c.hidden) ?? []).map(qco => 
                                                    <tr key={uuid()}>
                                                        <td>{qco.componentChanged}</td>
                                                        <td>{qco.changeType}</td>
                                                        <td>{qco.value}</td>
                                                    </tr>
                                                )
                                            }
                                            {!!!(engineerChangeOrderViewDTO.changes ?? []).length &&
                                                <tr key={uuid()}>
                                                    <td colSpan={3}>{'No Changes Found'}</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </Table>
                                </FlexCenterRow>
                                {!!(engineerChangeOrderViewDTO.changes?.filter(c => c.hidden) ?? []).length &&
                                    <>
                                        <FlexCenterRow>
                                            <h4 onClick={this.onToggleHidden}>
                                                <span>Hidden </span><FontAwesomeIcon icon={showHidden ? faCaretUp : faCaretDown} />
                                            </h4>
                                        </FlexCenterRow>                                    
                                        <FlexCenterRow>
                                            <Collapse in={showHidden} style={{width: "100%"} } >
                                                <Table style={{ width: "100%" }}>
                                                    <colgroup>
                                                        <col style={{ width: "30%" }} />
                                                        <col style={{ width: "20%" }} />
                                                        <col style={{ width: "50%" }} />
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th>Component</th>
                                                            <th>Change</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!!(engineerChangeOrderViewDTO.changes ?? []).length &&
                                                            (engineerChangeOrderViewDTO.changes?.filter(c => c.hidden) ?? []).map(qco =>
                                                                <tr key={uuid()}>
                                                                    <td>{qco.componentChanged}</td>
                                                                    <td>{qco.changeType}</td>
                                                                    <td>{qco.value}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Collapse>
                                        </FlexCenterRow>
                                    </>
                                }
                                <FlexCenterRow className="mt-3 mb-3">                                                                                                                                                
                                    <Button
                                        size="sm"
                                        type="button"
                                        color="secondary"
                                        disabled={this.state.saving}
                                        name="closeChangeOrderForm"
                                        onClick={this.onCloseClicked}
                                        className="ml-2">
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faTimes} />
                                        {"Close"}
                                    </Button>
                                </FlexCenterRow>
                                <FlexRow>
                                    <FormErrorResponseDisplay onClear={this.clearSaveErrors} response={errorResponse} />
                                </FlexRow>
                            </Fragment>
                        }
                    </AppPageForm>
                </Fragment>
            );
        }
    }
    //#endregion
}

export default withRouter(SalesOrderTrackingEngineerChangeOrderView);